/**
 * Sanitize a string to prevent XSS when embedding in HTML.
 * Escapes &, <, >, ", and ' characters.
 */
export function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/**
 * Write HTML safely to a window or iframe document using DOMParser + adoption.
 * Falls back to document.write if DOMParser fails.
 */
export function safeWriteToWindow(targetWindow, htmlString) {
    if (!targetWindow || targetWindow.closed) return;
    try {
        const doc = targetWindow.document;
        doc.open();
        doc.write(htmlString);
        doc.close();
    } catch (e) {
        // Fallback: try via DOMParser
        try {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(htmlString, 'text/html');
            const doc = targetWindow.document;
            doc.replaceChild(doc.adoptNode(parsed.documentElement), doc.documentElement);
        } catch (e2) {
            console.error('Failed to write to print window', e2);
        }
    }
}
